<!--
 * @Desc: 学校新闻
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-07-16 09:47:35
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-apply">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <BreadCrumb :objectData="objectData"></BreadCrumb>
        <div style="text-align: center;margin-top: 30px;">
            <el-button size="medium" type="primary" style="background-color: #409EFF;border-color: #409EFF;">复读生报名</el-button>
            <el-button size="medium" @click="$toPath('/FreshApply?active=' + $route.query.active)">应届生报名</el-button>
        </div>
        <section class="page-apply-section">
            <div class="container">
                <div class="apply-tips">
                    Tips：报名信息保存后，需在详情页面确认信息后提交，报名状态为“已提交”才算报名成功
                </div>
                <div style="padding-left: 24px;">
                    <el-button @click="toQuery" type="primary" plain>报名查询</el-button>
                    <!-- 
                        报名完未填写分数,密码,截图   status=0 &&(分数,密码,截图)任一为空  提示: 当前状态:已提交基本信息，等待完善信息                 标题显示 报名查询
                        报名完善信息后             status=0 &&(分数,密码,截图)都不为空  提示:当前状态:已提交报名信息，请等待审核                    标题显示 报名查询
                        审核成功后未支付            status=1 && can_pay==1  提示:当前状态:已通过审核,请缴费                                    标题显示 报名缴费
                        审核成功后已支付            status=1&& can_pay=0 提示:当前状态:请下载录取通知书，自行打印(黑白，彩色打的均可)，用于入学报道   标题显示 下载通知书
                        审核驳回                   status=2 提示:当前状态: 您提交的报名审核未通过，请核对信息后重新报名                            标题显示 报名查询
                        线下缴费                   status==1 && can_pay==2 提示:已完成线下缴费,请联系学校领取入学通知书                         标题显示 下载通知书
                     -->
                    <span v-if="bmStatus == 0 && copyData.zhongkao_score && copyData.check_score_password && copyData.score_pic" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:已提交报名信息，请等待审核</span>
                    <span v-else-if="bmStatus == 0" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:已提交基本信息，等待完善信息</span>
                    <span v-else-if="bmStatus == 1 && copyData.can_pay == 1" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:已通过审核,请线下缴费</span>
                    <span v-else-if="bmStatus == 1 && copyData.can_pay == 0" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:请下载录取通知书，自行打印(黑白，彩色打的均可)，用于入学报道<el-button style="margin-left:10px;background: #ecf5ff;border-color: #b3d8ff;color: #409eff;" plain type="primary" @click="toPrint">下载录取通知书</el-button></span>
                    <span v-else-if="bmStatus == 2" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:您提交的报名审核未通过，请核对信息后重新报名</span>
                    <span v-else-if="bmStatus == 1 && copyData.can_pay==2" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">已完成线下缴费,请联系学校领取入学通知书</span>
                    <!-- <el-button type="primary" v-if="bmStatus == 1 && copyData.can_pay == 1" style="border-color:#e22f24;background-color: #e22f24;margin-left: 20px;" @click="payment">去缴费</el-button> -->
                    <img style="width: 60%;display: block;margin: 20px auto;" v-if="bmStatus == 1 && copyData.can_pay == 1" src="../../public/statics/images/payEnd.jpg">
                </div>
                <div class="collapse-head" style="margin-top: 0">分数信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title nostar">高考分数</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.zhongkao_score"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                        <el-col :span="9">
                            <h1 class="title nostar">查询密码</h1>
                            <el-input style="display: none;"></el-input>
                            <el-input
                                style="width: 100%"
                                :type="passwordType"
                                v-model="viewData.check_score_password"
                                show-password
                                placeholder="请输入"
                            >
                            <!-- <i slot="suffix" class="el-input__icon el-icon-view"></i> -->
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                            <h1 class="title nostar">分数截图</h1>
                            <div v-if="thumbList4.length > 0" style="position: relative;overflow: hidden;">
                                <el-image 
                                    style="width: 167px; height: 98px;border: 1px dashed #999;"
                                    fit="cover"
                                    :src="$adddom(thumbList4[0].url)" 
                                    :preview-src-list="[thumbList4[0].url]">
                                </el-image>
                                <span
                                style="width:50px;height:50px;border-radius: 50px; background: rgba(0, 0, 0, 0.6);position: absolute;top:-25px;right:-25px;color:#fff;font-size: 12px;"
                                @click="handleRemove(4)"
                                >
                                <i class="el-icon-delete" style="margin-top:30px;margin-left: 10px;"></i>
                                </span>
                            </div>
                            <image-upload v-else ref="imageUpload4" :imageList="''" :pic="thu3" tipInfo=" " :maxNumber="1" :acceptType="'image/*'" @updateImg="onUpdateImg4($event)"></image-upload>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">年级信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title">年级</h1>
                            <el-select
                                v-model="viewData.grade_id"
                                style="width: 100%"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in gradeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option> </el-select
                        ></el-col>
                        <el-col :span="9">
                            <h1 class="title">学科组合</h1>
                            <div style="display: flex">
                                <el-select
                                    v-model="viewData.lessons_id"
                                    style="width:100%;"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in lessonsList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="6"></el-col>
                    </el-row>
                </div>
                <div class="collapse-head">学生信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title">学生姓名</h1>
                            <el-input
                                    style="width: 100%;"
                                    v-model="viewData.name"
                                    placeholder="请输入内容"
                                ></el-input>
                        </el-col>
                        <el-col :span="9">
                            <h1 class="title">学生性别</h1>
                            <el-select
                                v-model="viewData.sex"
                                style="width: 100%"
                                placeholder="请选择"
                            >
                            <el-option
                                    label="男"
                                    :value="1"
                                >
                                </el-option>
                                <el-option
                                    label="女"
                                    :value="2"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6"></el-col>
                    </el-row>
                </div>
                <section class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title">证件类别</h1>
                            <div style="display: flex">
                                <el-select
                                    v-model="viewData.card_type_id"
                                    style="width: 104px"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in cardTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <el-input
                                    style="width: 300px; margin-left: 8px"
                                    v-model="viewData.card_num"
                                    placeholder="请输入内容"
                                ></el-input>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <h1 class="title">民族</h1>
                            <el-select
                                v-model="viewData.nation_id"
                                style="width: 100%"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in nationList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="5">
                            <h1 class="title">政治面貌</h1>
                            <el-select
                                v-model="viewData.zzmm_id"
                                style="width: 100%"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in zzmmList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="5">
                            <h1 class="title">家庭住址</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.address"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                    </el-row>
                </section>
                <section class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title">高考准考证号</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.zkzh"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                        <el-col :span="9">
                            <h1 class="title">毕业学校</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.czby_school"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                    </el-row>
                </section>
                <div class="collapse-head">家长信息</div>
                <section class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="9">
                            <h1 class="title">家长姓名</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.jz_name"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                        <el-col :span="9">
                            <h1 class="title">与学生关系</h1>
                            <el-select
                                v-model="viewData.relationship_id"
                                style="width: 100%"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in relationshipList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6">
                            <h1 class="title">家长手机号</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.jz_phone"
                                placeholder="请输入"
                            ></el-input>
                        </el-col>
                    </el-row>
                </section>
                <div class="collapse-head">附件信息</div>
                <section class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="4">
                            <h1 class="title">身份证件照片</h1>
                            <div v-if="thumbList1.length > 0" style="position: relative;overflow: hidden;">
                                <el-image 
                                    style="width: 167px; height: 98px;border: 1px dashed #999;"
                                    fit="cover"
                                    :src="$adddom(thumbList1[0].url)" 
                                    :preview-src-list="[$adddom(thumbList1[0].url)]">
                                </el-image>
                                <span
                                style="width:50px;height:50px;border-radius: 50px; background: rgba(0, 0, 0, 0.6);position: absolute;top:-25px;right:-25px;color:#fff;font-size: 12px;"
                                @click="handleRemove(1)"
                                >
                                <i class="el-icon-delete" style="margin-top:30px;margin-left: 10px;"></i>
                                </span>
                            </div>
                            <image-upload v-else ref="imageUpload1" :imageList="''" :pic="thu1" tipInfo=" " :maxNumber="1" :acceptType="'image/*'" @updateImg="onUpdateImg1($event)"></image-upload>
                        </el-col>
                        <el-col :span="4">
                            <div style="height: 30px"></div>
                            <div v-if="thumbList2.length > 0" style="position: relative;overflow: hidden;">
                                <el-image 
                                    style="width: 167px; height: 98px;border: 1px dashed #999;"
                                    fit="cover"
                                    :src="$adddom(thumbList2[0].url)" 
                                    :preview-src-list="[$adddom(thumbList2[0].url)]">
                                </el-image>
                                <span
                                style="width:50px;height:50px;border-radius: 50px; background: rgba(0, 0, 0, 0.6);position: absolute;top:-25px;right:-25px;color:#fff;font-size: 12px;"
                                @click="handleRemove(2)"
                                >
                                <i class="el-icon-delete" style="margin-top:30px;margin-left: 10px;"></i>
                                </span>
                            </div>
                            <image-upload v-else ref="imageUpload2" :imageList="''" :pic="thu2" tipInfo=" " :maxNumber="1" :acceptType="'image/*'" @updateImg="onUpdateImg2($event)"></image-upload>
                        </el-col>
                        <el-col :span="4">
                            <h1 class="title">高考准考证照片</h1>
                            <div v-if="thumbList3.length > 0" style="position: relative;overflow: hidden;">
                                <el-image 
                                    style="width: 167px; height: 98px;border: 1px dashed #999;"
                                    fit="cover"
                                    :src="$adddom(thumbList3[0].url)" 
                                    :preview-src-list="[$adddom(thumbList3[0].url)]">
                                </el-image>
                                <span
                                style="width:50px;height:50px;border-radius: 50px; background: rgba(0, 0, 0, 0.6);position: absolute;top:-25px;right:-25px;color:#fff;font-size: 12px;"
                                @click="handleRemove(3)"
                                >
                                <i class="el-icon-delete" style="margin-top:30px;margin-left: 10px;"></i>
                                </span>
                            </div>
                            <image-upload v-else ref="imageUpload3" :imageList="''" :pic="thu3" tipInfo=" " :maxNumber="1" :acceptType="'image/*'" @updateImg="onUpdateImg3($event)"></image-upload>
                        </el-col>
                    </el-row>
                </section>
                <div class="btn-hold" style="padding-bottom: 10px;align-items: center;">
                    <el-checkbox v-model="xieyi"></el-checkbox><span @click="xieyiShow = true" style="margin-left: 10px;cursor: pointer;">我已阅读并同意<span style="color:#409eff">《用户协议》</span></span>
                </div>
                <div class="btn-hold">
                    <el-button type="primary" class="btn-cancel" style="border-color:#e22f24;" v-if="viewData.status != 1" @click="resetForm">取 消</el-button>
                    <el-button type="primary" class="btn-sure" style="border-color:#e22f24;" v-if="viewData.status != 1" @click="submit">提 交</el-button>
                </div>
            </div>
        </section>
        <!-- 查询弹层 -->
        <el-dialog title="信息查询" :visible.sync="dialogFormVisible" :center="true" :close-on-click-modal="false">
            <el-form :model="form" label-width="100">
                <el-form-item label="手机号">
                    <el-input v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="form.card_num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="querySure">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 协议弹层 -->
        <el-dialog title="用户协议" :visible.sync="xieyiShow" :center="true" :close-on-click-modal="false">
            {{ configData.xieyi }}
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="xieyiShow = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<style>
.avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/* .avatar-uploader .el-upload:hover {
    border-color: #409eff;
} */
</style>

<script>
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import ImageUpload from '@/components/image'
export default {
    name: "home",
    data() {
        return {
            passwordType: "password",
            xieyi:false,//协议是否选中
            xieyiShow:false,
            configData:'',
            bmStatus: '-1',// 报名状态
            dialogFormVisible:false,//查询弹层
            form:{
                phone:'',
                card_num:'',
            },
            thu1: require("../../public/statics/images/Apply/icon-upload1.png"),
            thu2: require("../../public/statics/images/Apply/icon-upload2.png"),
            thu3: require("../../public/statics/images/Apply/icon-upload3.png"),
            thumbList1: [], // 图片暂存
            thumbList2: [], // 图片暂存
            thumbList3: [], // 图片暂存
            thumbList4: [], // 图片暂存
            // 菜单选中
            active: this.$route.query.active,
            recommendData: {},
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [],
                thu:''
            },
            // 顶部图片
            imageUrl1: require("../../public/statics/images/Banner/banner1.jpg"),
            gradeList: [],
            cardTypeList: [],
            nationList: [],
            relationshipList: [],
            zzmmList: [],
            lessonsList: [],
            copyData:{},
            viewData:{
                id:'',
                check_score_password:'',
                name:'',
                sex:'',
                grade_id:'',
                lessons_id:'',
                card_type_id:'',
                card_num:'',
                nation_id:'',
                zzmm_id:'',
                address:'',
                zkzh:'',
                czby_school:'',
                zhongkao_score:'',
                jz_name:'',
                relationship_id:'',
                jz_phone:'',
                card_pic:'',
                card_pic_back:'',
                zkz_pic:'',
                score_pic:'',
            }
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        ImageUpload
    },
    created() {
        this.getAllSelect()
        this.cateDetail()
        this.getConfig()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 打印通知书
        toPrint(){
            window.open(this.viewData.zip_url)
        },
        // 获取网址信息配置
        getConfig(){
            let that = this
            this.$api.index
                .getConfig({})
                .then((res) => {
                    that.configData = res.result
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                    that.objectData.thu = that.cateData.thumb
                }
            })
        },
        // 查询完去缴费
        payment(){
            console.log('去缴费')
            let that = this
            that.$api.index.orderCreate({apply_id:that.viewData.id}).then((res)=>{
                if(res.code == 200) {
                    that.$toPath('/PayType',{
                        id:res.result.id,
                        total_price:res.result.total_price
                    })
                }
            })
        },
        // 查询弹层
        toQuery(){
            this.form= {
                phone:'',
                card_num:'',
            }
            this.dialogFormVisible = true
        },
        // 弹层确认事件
        querySure(){
            this.resetForm()
            let that = this
            that.$api.index.applyDetail(that.form).then((res)=>{
                if(res.code == 200) {
                    that.copyData = JSON.parse(JSON.stringify(res.result))
                    that.bmStatus = that.copyData.status
                    that.xieyi = true

                    that.viewData = res.result
                    that.dialogFormVisible = false

                    // 审核通过，不能编辑
                    if (that.viewData.status == 1) {
                        $('.page-apply .collapse-body').addClass('noEvents')
                    } else {
                        $('.page-apply .collapse-body').removeClass('noEvents')
                    }

                    if (that.viewData.card_pic) {
                        that.thumbList1 = [
                            {
                                name: that.viewData.card_pic,
                                path: that.viewData.card_pic,
                                url: that.viewData.card_pic,
                            }
                        ]
                    }
                    if (that.viewData.card_pic_back) {
                        that.thumbList2 = [
                            {
                                name: that.viewData.card_pic_back,
                                path: that.viewData.card_pic_back,
                                url: that.viewData.card_pic_back,
                            }
                        ]
                    }
                    if (that.viewData.zkz_pic) {
                        that.thumbList3 = [
                            {
                                name: that.viewData.zkz_pic,
                                path: that.viewData.zkz_pic,
                                url: that.viewData.zkz_pic,
                            }
                        ]
                    }
                    if (that.viewData.score_pic) {
                        that.thumbList4 = [
                            {
                                name: that.viewData.score_pic,
                                path: that.viewData.score_pic,
                                url: that.viewData.score_pic,
                            }
                        ]
                    }
                } else {
                    that.bmStatus = '-1'
                }
            })
        },
        // 清空图片
        handleRemove(type){
            if (type ==1){
                this.thumbList1 = []
            } else if(type ==2) {
                this.thumbList2 = []
            } else if(type ==3) {
                this.thumbList3 = []
            } else if(type ==4) {
                this.thumbList4 = []
            }
        },
        /**
		 * @name: 图片更新
		 * @param {*} val
		 * @return {*}
		 * @desc: 
		 */		
         onUpdateImg1(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList1 = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        // 图片更新
        onUpdateImg2(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList2 = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        // 图片更新
        onUpdateImg3(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList3 = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        // 图片更新
        onUpdateImg4(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList4 = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        // 获取所有下拉列表
        getAllSelect() {
            let that = this
            this.$api.index
                .applySelect({})
                .then((res) => {
                    that.gradeList = res.result.grade
                    that.viewData.grade_id = that.gradeList[0].id
                    that.cardTypeList = res.result.card_type
                    that.nationList = res.result.nation
                    that.relationshipList = res.result.relationship
                    that.zzmmList = res.result.zzmm
                    that.lessonsList = res.result.lessons
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        /**
         * @name: 调用接口 提交数据
         * @return {*}
         * @desc:
         */
         submit() {
            if(!this.xieyi){
                // this.$message.error('请阅读并同意用户协议')
                this.$alert('请阅读并同意用户协议', '', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
                return
            }
            // 调用接口
            console.log(this.viewData);
            console.log(this.thumbList1);
            console.log(this.thumbList2);
            console.log(this.thumbList3);
            console.log(this.thumbList4);
            let that = this;
            if(that.viewData.id){
                if (this.thumbList1.length > 0) {
                    this.viewData.card_pic = this.thumbList1[0].url
                }
                if (this.thumbList2.length > 0) {
                    this.viewData.card_pic_back = this.thumbList2[0].url
                }
                if (this.thumbList3.length > 0) {
                    this.viewData.zkz_pic = this.thumbList3[0].url
                }
                if (this.thumbList4.length > 0) {
                    this.viewData.score_pic = this.thumbList4[0].url
                }
                that.$api.index.applyEdit(that.viewData).then((res)=>{
                    if(res.code == 200) {
                        // that.$message.success(res.msg)
                        that.$alert(res.msg, '', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                        that.resetForm()
                    }
                })
                return
            }
            if (this.thumbList1.length > 0) {
                this.viewData.card_pic = this.thumbList1[0].url
            }
            if (this.thumbList2.length > 0) {
                this.viewData.card_pic_back = this.thumbList2[0].url
            }
            if (this.thumbList3.length > 0) {
                this.viewData.zkz_pic = this.thumbList3[0].url
            }
            if (this.thumbList4.length > 0) {
                this.viewData.score_pic = this.thumbList4[0].url
            }
            that.$api.index.applySubmit(that.viewData).then((res)=>{
                if(res.code == 200) {
                    that.$alert(res.msg, '', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                    that.resetForm()
                }
            })
        },
        // 清空表单
        resetForm(){
            this.xieyi = false
            this.thumbList1 = []
            this.thumbList2 = []
            this.thumbList3 = []
            this.thumbList4 = []
            this.bmStatus = '-1'
            this.viewData = {
                id:'',
                check_score_password:'',
                name:'',
                sex:'',
                grade_id:this.viewData.grade_id,
                lessons_id:'',
                card_type_id:'',
                card_num:'',
                nation_id:'',
                zzmm_id:'',
                address:'',
                zkzh:'',
                czby_school:'',
                zhongkao_score:'',
                jz_name:'',
                relationship_id:'',
                jz_phone:'',
                card_pic:'',
                card_pic_back:'',
                zkz_pic:'',
                score_pic:'',
            }
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noEvents{
    pointer-events: none;
}
.page-apply {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.page-apply .page-apply-section .container {
    margin-top: 30px;
    margin-bottom: 30px;
    background: #ffffff;
    padding-right: 16px;
}
.page-apply .container .apply-tips {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 16px;
    color: rgba(226, 47, 36, 1);
    padding-top: 19px;
    margin-bottom: 15px;
    padding-left: 24px;
}
.page-apply .container .collapse-head {
    width: 1184px;
    line-height: 56px;
    padding-left: 48px;
    position: relative;
    margin-top: 10px;
}
.page-apply .container .collapse-head::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    width: 12px;
    height: 8px;
    background: url(../../public/statics/images/down.png) no-repeat;
}
.page-apply .container .collapse-head::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
}
.page-apply .container .collapse-body {
    width: 1184px;
    padding-left: 24px;
    position: relative;
    margin: 24px 0;
}
.page-apply .container .collapse-body .title {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
    position: relative;
    padding-left: 12px;
}
.page-apply .container .collapse-body .title::after{
    content: '*';
    position: absolute;
    top: 2px;
    left: 0;
    color: #e22f24;
}
.page-apply .container .collapse-body .title.nostar{
    padding-left: 0;
}
.page-apply .container .collapse-body .title.nostar::after{
    display:none;
}
.page-apply .container .btn-hold {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
}
.page-apply .container .btn-hold .btn-cancel {
    width: 118px;
    height: 44px;
    background: #e22f24;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
}
.page-apply .container .btn-hold .btn-sure {
    width: 118px;
    height: 44px;
    background: #e22f24;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
    margin-left: 15px;
}
</style>